module.exports = __webpack_public_path__ + "static/media/castledown-heavy.62fe46d5.ttf";